import {
  BrainCircuit,
  ChartNoAxesCombined,
  Database,
  Home,
  Layers3,
  ScrollText,
  Server,
  Settings,
  type LucideIcon,
} from "lucide-react";
import { BrandMark } from "../ui/BrandMark";

const ITEMS: readonly { label: string; icon: LucideIcon; active?: boolean }[] = [
  { label: "Overview", icon: Home, active: true },
  { label: "Servers", icon: Server },
  { label: "Subspaces", icon: Layers3 },
  { label: "State", icon: Database },
  { label: "Inference", icon: BrainCircuit },
  { label: "Analytics", icon: ChartNoAxesCombined },
  { label: "Logs", icon: ScrollText },
  { label: "Settings", icon: Settings },
];

/** Decorative icon-rail sidebar for the marketing dashboard preview. */
export function PreviewSidebar() {
  return (
    <div className="preview-sidebar">
      <div className="preview-sidebar-mark">
        <BrandMark size={20} />
      </div>
      <ul className="preview-sidebar-list">
        {ITEMS.map((item) => (
          <li key={item.label}>
            <span
              className={
                item.active
                  ? "preview-sidebar-item preview-sidebar-item--active"
                  : "preview-sidebar-item"
              }
            >
              <item.icon size={18} strokeWidth={1.6} absoluteStrokeWidth />
              <span className="preview-sidebar-label">{item.label}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
